import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';

const THEMES = {
  blue: { color: '#3b82f6', card: 'from-blue-50/80 border-blue-100', glow: 'bg-blue-400/20', btn: 'from-blue-500 to-blue-700 shadow-blue-600/30', icon: 'bg-blue-50 text-blue-600' },
  red: { color: '#f43f5e', card: 'from-rose-50/80 border-rose-100', glow: 'bg-rose-400/20', btn: 'from-orange-500 to-rose-600 shadow-rose-600/30', icon: 'bg-rose-50 text-rose-500' },
  green: { color: '#10b981', card: 'from-emerald-50/80 border-emerald-100', glow: 'bg-emerald-400/20', btn: 'from-emerald-500 to-green-700 shadow-emerald-600/30', icon: 'bg-emerald-50 text-emerald-600' },
};

export const LibraryCard = ({ to, theme, image, title, desc, features, cta, testId, delay }) => {
  const { isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const th = THEMES[theme];
  return (
    <div className="art-reveal flex" style={{ animationDelay: `${delay}ms` }}>
      <Link to={to} data-testid={testId} aria-label={title} style={{ '--glow': th.color }}
        className={`plan-glow group relative w-full cursor-pointer flex flex-col items-center text-center rounded-3xl border bg-gradient-to-b to-white ${th.card} p-5 sm:p-6 shadow-sm outline-none`}>
        <div className="relative w-full h-36 sm:h-40 mb-3 flex items-center justify-center">
          <div className={`absolute w-32 h-32 rounded-full blur-3xl ${th.glow}`} />
          <img src={image} alt="" className="relative h-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-500" />
        </div>
        <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-2">{title}</h2>
        <p className="text-slate-500 text-sm leading-relaxed max-w-xs mb-5 min-h-[2.75rem]">{desc}</p>
        <div className="grid grid-cols-3 gap-2 w-full mb-5">
          {features.map(({ Icon, label, strong }) => (
            <div key={label} className="flex flex-col items-center gap-2">
              <span className={`w-10 h-10 rounded-full flex items-center justify-center ${th.icon}`}><Icon className="w-4 h-4" /></span>
              <span className={`text-xs leading-tight ${strong ? 'font-extrabold text-slate-900' : 'text-slate-600'}`}>{label}</span>
            </div>
          ))}
        </div>
        <span data-testid={`${testId}-cta`}
          className={`mt-auto w-full h-11 rounded-xl bg-gradient-to-r ${th.btn} text-white font-bold text-sm sm:text-base inline-flex items-center justify-center gap-2 shadow-lg group-hover:brightness-110 transition-[filter]`}>
          {cta}<Arrow className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
        </span>
      </Link>
    </div>
  );
};
